<template>
  <span>
    <exportar-nfse-maior-periodo />
    <Dialog 
      header="Exportar Notas Fiscais" 
      :visible.sync="showExportarNotas"
      :style="{ width: '90vw', maxWidth: '750px' }" 
      :contentStyle="{ overflow: 'visible' }" 
      :modal="true" 
      :closable="false"
    >
      <div class="container-fluid p-0">
        <div id="topo" class="row">
          <div class="col-12 col-sm-6 mb-3">
            <span class="p-fluid">
              <label class="font-weight-bold mb-1" for="dataIniModal1">Data Inicial *</label>
              <CustomCalendar id="dataIniModal1" name="dataIni" v-model="dataFatoGeradorIni" :showIcon="true" dateFormat="dd/mm/yy"
                placeholder="DD/MM/AAAA" @keyup.enter="pesquisar" v-maska="'##/##/####'" />
            </span>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <span class="p-fluid">
              <label class="font-weight-bold mb-1" for="dataFimModal1">Data Final *</label>
              <CustomCalendar id="dataFimModal1" name="dataFim" v-model="dataFatoGeradorFim" :showIcon="true" dateFormat="dd/mm/yy"
                placeholder="DD/MM/AAAA" @keyup.enter="pesquisar" v-maska="'##/##/####'" />
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mb-3">
            <span class="p-fluid">
              <label class="font-weight-bold mb-1" for="tomadorModal1">Tomador</label>
              <AutoComplete id="tomadorModal1" v-model="selectedPessoa" :dropdown="true" :suggestions="filteredPessoas"
                @complete="searchPessoa($event)" @keyup.enter="pesquisar" field="detail"
                placeholder="Pesquisar CPF/CNPJ/Nome Tomador" />
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mb-3">
            <span class="p-fluid">
              <label class="font-weight-bold mb-1" for="servicoModal1">Serviço</label>
              <AutoComplete id="servicoModal1" v-model="selectedServico" :dropdown="true" :suggestions="filteredServicos"
                field="detail" @complete="searchServico($event)" placeholder="Pesquisar Serviço">
                <template #item="slotProps">
                  <div class="p-fluid" style="max-width: 100%">
                    {{ slotProps.item.detail }}
                  </div>
                </template>
              </AutoComplete>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mb-2">
            <span class="p-fluid">
              <label class="font-weight-bold mb-1" for="situacaoModal1">Situação *</label>
              <Dropdown id="situacaoModal1" v-model="filtroSituacao" :options="filtroSituacoes" optionLabel="name"
                placeholder="Selecione uma Situação" />
            </span>
          </div>
        </div>
      </div>

      <hr class="my-3" />

      <div class="d-flex flex-wrap justify-content-between align-items-center pt-1">
        <div class="d-flex flex-wrap align-items-center mb-2">
          <Button @click="showExportarNotas = false" type="button" label="Fechar"
            class="p-button-secondary mr-2 mb-1" icon="pi pi-times" />
          <Button @click="exportarMaiorPeriodo()" href="#topo" type="button" label="Exportação Assíncrona"
            class="p-button-info mr-2 mb-1" icon="pi pi-external-link" :disabled="loading" />
        </div>
        <div class="d-flex flex-wrap align-items-center mb-2">
          <Button @click="downloadListagemXml(false)" href="#topo" type="button" label="Exportar XML (Abrasf)"
            class="p-button-success mr-2 mb-1" icon="pi pi-download" :disabled="loading" />
          <Button @click="downloadListagemXml(true)" href="#topo" type="button" label="Exportar XML (Nacional)"
            class="p-button-success mb-1" icon="pi pi-download" :disabled="loading" />
        </div>
      </div>
    </Dialog>
  </span>
</template>

<script>
import { maska } from 'maska'
import ContribuinteServicoService from "@/services/tributario/contribuinte.servico.service";
import PessoaService from "@/services/nfse/pessoa.service";
import LoginService from "@/services/acesso/login.service";
import ReportService from "@/services/report.service";
import ExportarNfseMaiorPeriodo from './ExportarNfseMaiorPeriodo.vue';
import CustomCalendar from "@/components/global/CustomCalendar.vue";

export default {
  directives: { maska },
  name: "ExportarNotasFiscais",
  components: { ExportarNfseMaiorPeriodo, CustomCalendar },

  created() {
    this.currentUser = LoginService.currentUserValue;
    this.notaAvulsa = this.currentUser.emiteNotaAvulsa;

    this.$root.$on("notaFiscal:exportar", () => {
      this.showExportarNotas = true;
      this.dataFatoGeradorIni = null;
      this.dataFatoGeradorFim = null;
      this.selectedPessoa = null;
      this.filteredPessoas = null;
      this.selectedServico = null;
      this.filteredServicos = null;
    });
  },

  data() {
    return {
      showExportarNotas: false,
      currentUser: null,
      dataFatoGeradorIni: null,
      dataFatoGeradorFim: null,
      selectedPessoa: null,
      filteredPessoas: null,
      selectedServico: null,
      filteredServicos: null,
      notaAvulsa: null,
      filtroSituacao: "",
      filtroSituacoes: [
        { name: "Todos", key: "T" },
        { name: "Ativa", key: "A" },
        { name: "Cancelada", key: "C" },
        { name: "Substituida", key: "S" }
      ],
    };
  },

  methods: {
    searchPessoa(event) {
      setTimeout(async () => {
        this.filteredPessoas = await PessoaService.findAllByConttribuinteFiltro(
          event.query,
          ""
        );
      }, 550);
    },
    searchServico(event) {
      if (this.currentUser.configuracao.idBolHabilitaCnaeNf == "N") {
        if (this.notaAvulsa) {
          // Se for nota avulsa exibir todos os serviços
          setTimeout(async () => {
            this.filteredServicos =
              await ContribuinteServicoService.findAllNfAvulsa(
                event.query,
                this.currentUser.contribuinte.idContribuinte
              );
          }, 250);
        } else {
          setTimeout(async () => {
            this.filteredServicos =
              await ContribuinteServicoService.findAllServicosByContribuinteFiltro(
                event.query,
                this.currentUser.contribuinte.idContribuinte
              );
          }, 250);
        }
      } else {
        // Buscar lista de CNAE, posteriormente...
      }
    },
    downloadListagemXml(nacional = false) {
      var msg = null;
      if (!this.currentUser.contribuinte.idContribuinte) {
        msg = "É necessário informar o contribuinte!";
      } else if (!this.dataFatoGeradorIni) {
        msg = "É necessário informar a data Inicial!";
      } else if (!this.dataFatoGeradorFim) {
        msg = "É necessário informar a data Final!";
      } else if (!this.filtroSituacao && !this.filtroSituacao.key) {
        msg = "É necessário informar uma Situação!"
      }

      if (!msg) {
        this.processando(true);
        ReportService.downloadListXmlCompleto(
          this.currentUser.contribuinte.idContribuinte,
          this.dataFatoGeradorIni,
          this.dataFatoGeradorFim,
          (this.selectedPessoa && this.selectedPessoa.documento ? this.selectedPessoa.documento : ""),
          (this.selectedServico && this.selectedServico.idServico ? this.selectedServico.idServico.idServicoItem : ""),
          this.$root,
          (this.filtroSituacao && this.filtroSituacao.key != 'T' ? this.filtroSituacao.key : null),
          null,
          nacional
        )
          .then(
            (data) => {
              console.log(data);
            },
            (error) => {
              console.log(error);
            }
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        this.$root.$emit("alert:warn", msg);
      }
    },

    exportarMaiorPeriodo() {
      this.$root.$emit("notaFiscal:exportarMaiorPeriodo");
    },

    processando(show) {
      if (show) {
        this.$parent.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.$parent.loading = false;
        this.$root.$emit("loading:hide");
      }
    },
  },

  computed: {
    loading() {
      return this.$parent.loading;
    },
  },
};
</script>

<style scoped></style>